import { get, post, put } from "../api";

export async function getPendingListings() {
    return await get('tool/pending-validation');
}

export async function approvePendingListing(publicId) {
    return await post({}, `tool/pending-validation/${publicId}/approve`);
}

export async function rejectPendingListing(publicId) {
    return await post({}, `tool/pending-validation/${publicId}/reject`);
}

export async function updatePendingListingPicture(publicId, base64Picture) {
    return await post({ base64Picture }, `tool/pending-validation/${publicId}/picture`);
}

export async function updatePendingListing(publicId, values) {
    return await put(values, `tool/pending-validation/${publicId}`);
}
